import React from 'react';
import dayjs from 'dayjs';
import { observable, action, makeObservable } from 'mobx';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { Modal, Button, Box, Typography } from '@mui/material';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import { formatDate } from '/@/app/utils';
import { Linkify } from '/@/app/linkify';
import { useApi} from '/@/app/Api';
import { tipState, injectApi } from '/@/app/components/TipOfTheDay/TipState.js';


const TipModal = observer(({ tipState }) => {
    const api=useApi();
    const { t } = useTranslation();
    React.useEffect(() => { injectApi(api); }, [api]);

    // FIXME use something standard.
    const escapeHTML = (str) => {
        return str.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }
    // ensure displaying newlines in HTML
    const text = escapeHTML(tipState.tip.text);

    return (
        <Modal
            open={ tipState.modalOpened }
            onClose={() => { tipState.modalClose(); }}
        >
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                maxHeight: '90vh',
                maxWidth: { xs: '95vw', sm: '90vw', md: '600px' },
                width: { xs: '95vw', sm: '90vw' },
                backgroundColor: 'white',
                padding: 3,
                borderRadius: 3,
                display: 'flex',
                flexDirection: 'column',
                outline: 'none',
                textAlign: "center",

            }}>
                <Box sx={{ overflowY: 'auto', }}>
                    <Typography variant="h5" gutterBottom>{t("Совет дня")}</Typography>
                    <Typography variant="body1" gutterBottom>
                        {formatDate(tipState.date)}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{ mt: 2, mb: 3, textAlign: "left" }}
                    >
                        <Linkify text={text} />
                    </Typography>

                    <Button
                        sx={{ alignSelf: "center" }}
                        onClick={() => {
                            tipState.modalClose();
                        }}
                    >{t("button-close")}</Button>
                </Box>
            </Box>
        </Modal>
    )
});


export const TipOfTheDay = () => {
    return <_TipOfTheDay tipState={tipState} />;
};


const _TipOfTheDay = observer(({ tipState }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    if (tipState.tip === null) {
        return <></>;
    }

    let modalAllowed = !!(tipState.tip.text);

    return (
        <>
            <Box
                onClick={() => { tipState.modalShow(); }}
                sx={{
                    textAligh: "center",
                    pr: 1.5, pl: 1.5, pt: 2, pb: 2,
                    m: 0.5,
                    backgroundColor: '#bef6ed',
                    borderRadius: 2,
                    cursor: modalAllowed ? "pointer": "default",
                }}
            >
                <Typography variant="body2" sx={{
                    mb: 1,
                }}>
                    {t("Сегодня")} {formatDate(tipState.date)}
                </Typography>
                <Typography variant="body1" sx={{
                    lineHeight: "1.2em",
                }}>

                    {tipState.tip.caption} {" "}
                    {modalAllowed &&
                        <AdsClickIcon sx={{ position: "relative", top: "0.2em", color: theme.palette.secondary.main }} fontSize="smaller" />
                    }
                </Typography>
            </Box>
            {modalAllowed &&
                <TipModal tipState={tipState} />
            }
        </>
    );
});
